import { Link, useLocation } from 'react-router-dom';
import { Home, Images, CalendarDays, Users, Plus } from 'lucide-react';

export default function MobileNav({ onCreatePost }) {
  const location = useLocation();

  const baseNavItems = [
    { path: '/', icon: Home, label: 'Feed' },
    { path: '/albums', icon: Images, label: 'Albums' },
    { path: '/calendar', icon: CalendarDays, label: 'Calendar' },
    { path: '/family', icon: Users, label: 'Family' },
  ];

  const navItems = onCreatePost
    ? [
        baseNavItems[0],
        baseNavItems[1],
        { action: 'create', icon: Plus, label: 'Post' },
        baseNavItems[2],
        baseNavItems[3],
      ]
    : baseNavItems;

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 glass-header border-t border-stone-200/50 z-50" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around py-2 px-4">
        {navItems.map((item, index) => (
          item.action ? (
            <button
              key={index}
              onClick={onCreatePost}
              className="flex flex-col items-center gap-1 p-2 -mt-6"
              data-testid="mobile-create-btn"
            >
              <div className="bg-teal-600 p-3 rounded-full shadow-lg">
                <item.icon className="w-6 h-6 text-white" />
              </div>
            </button>
          ) : (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 p-2 ${
                isActive(item.path) ? 'text-teal-600' : 'text-stone-500'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          )
        ))}
      </div>
    </nav>
  );
}
